module.exports = __webpack_public_path__ + "static/media/Roundhouse.316ca644.png";